import createIcon from '../../createIcon';

/**
 * @component @name Superscript
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNTYwNCA3SDE3LjU2MDRWOEgyMC41NjA0VjlIMTYuNTYwNFY3QzE2LjU2MDQgNi40NSAxNy4wMTA0IDYgMTcuNTYwNCA2SDE5LjU2MDRWNUgxNi41NjA0VjRIMTkuNTYwNEMyMC4xMTA0IDQgMjAuNTYwNCA0LjQ1IDIwLjU2MDQgNVY2QzIwLjU2MDQgNi41NSAyMC4xMTA0IDcgMTkuNTYwNCA3Wk0zLjQ0MDQzIDIwSDYuMTAwNDNMOS41MDA0MyAxNC41OEg5LjYyMDQzTDEzLjAyMDQgMjBIMTUuNjgwNEwxMS4wMzA0IDEyLjczTDE1LjM3MDQgNkgxMi42OTA0TDkuNjIwNDMgMTAuOTlIOS41MDA0M0w2LjQxMDQzIDZIMy43NTA0M0w4LjA3MDQzIDEyLjczTDMuNDQwNDMgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Superscript = createIcon('Superscript', [
  [
    'path',
    {
      d: 'M19.5604 7H17.5604V8H20.5604V9H16.5604V7C16.5604 6.45 17.0104 6 17.5604 6H19.5604V5H16.5604V4H19.5604C20.1104 4 20.5604 4.45 20.5604 5V6C20.5604 6.55 20.1104 7 19.5604 7ZM3.44043 20H6.10043L9.50043 14.58H9.62043L13.0204 20H15.6804L11.0304 12.73L15.3704 6H12.6904L9.62043 10.99H9.50043L6.41043 6H3.75043L8.07043 12.73L3.44043 20Z',
      key: '17qsep',
    },
  ],
]);

export default Superscript;
